import React, { useState } from 'react'
import { Table, Pagination } from "react-bootstrap";
import './UpdateTable.css';
import TaskModal from '../TaskModal/TaskModal';
import FieldUpdateModal from '../FieldUpdateModal/FieldUpdateModal';

const UpdateTable = ({ component, taskData }) => {
    // Example Data
  // const tableData = [
  //   { id: "TSK-001", type: "Document Update", subtype: "APP-2025", desc: "KYC Verification", created: "Document Collection", status: "OPEN", priority: "HIGH" },
  //   { id: "TSK-002", type: "Document Update", subtype: "APP-2025", desc: "KYC Verification", created: "Document Collection", status: "COMPLETED", priority: "MEDIUM" },
  //   { id: "TSK-002", type: "Document Update", subtype: "APP-2025", desc: "KYC Verification", created: "Document Collection", status: "PENDING", priority: "LOW" },
  //   { id: "TSK-002", type: "Document Update", subtype: "APP-2025", desc: "KYC Verification", created: "Document Collection", status: "REJECTED", priority: "MEDIUM" },
  //   { id: "TSK-002", type: "Document Update", subtype: "APP-2025", desc: "KYC Verification", created: "Document Collection", status: "REJECTED", priority: "MEDIUM" }
  // ];

  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showFieldUpdateModal, setShowFieldUpdateModal] = useState(false);

  // Pagination
  const totalPages = 10;
  const [page, setPage] = useState(1);

  const paginationItems = [];
  paginationItems.push(
    <Pagination.Prev onClick={() => setPage(Math.max(1, page - 1))} />
  );

  for (let i = 1; i <= 5; i++) {
    paginationItems.push(
      <Pagination.Item key={i} active={page === i} onClick={() => setPage(i)}>
        {i}
      </Pagination.Item>
    );
  }

  paginationItems.push(<Pagination.Ellipsis disabled />);
  paginationItems.push(
    <Pagination.Item active={page === 12} onClick={() => setPage(12)}>
      12
    </Pagination.Item>
  );
  paginationItems.push(<Pagination.Ellipsis disabled />);
  paginationItems.push(
    <Pagination.Item active={page === 10} onClick={() => setPage(10)}>
      10
    </Pagination.Item>
  );

  paginationItems.push(
    <Pagination.Next onClick={() => setPage(Math.min(totalPages, page + 1))} />
  );

  // if(taskData?.length === 0){
  //   // return (
  //   //   <div style={{
  //   //     width: "100%",
  //   //     height: "70vh",
  //   //     display: "flex",
  //   //     alignItems: "center",
  //   //     justifyContent: "center",
  //   //     background: "white",
  //   //     borderRadius: "10px",
  //   //     marginTop: "20px"
  //   //   }}>
  //   //     <p>No Subtasks found</p>
  //   //   </div>
  //   // )
  //   // return (
  //   //   <></>
  //   // )

  //   return (
  //     <div className="task-table-wrapper">
  //         <div className="table-container">
  //         <Table hover borderless className="task-table mb-0">
  //           <thead>
  //             <tr>
  //               <th>Task ID</th>
  //               <th>Type</th>
  //               <th>Subtype</th>
  //               <th>Assigned To</th>
  //               <th>Status</th>
  //               <th>Priority</th>
  //               <th>Created By</th>
  //             </tr>
  //           </thead>

  //           <tbody>
  //             <tr>
  //               <td
  //                 colSpan={7}   // number of columns
  //                 className="no-data-cell"
  //               >
  //                 No subtasks found
  //               </td>
  //             </tr>
  //           </tbody>
  //         </Table>
  //       </div>
  //     </div>
  //   )
  // }

  const hasNoData = Array.isArray(taskData) && taskData.length === 0;


  return (
    <div className="task-table-wrapper">
        <div className="table-container">
        <Table hover borderless className="task-table mb-0">
          <thead>
            <tr>
              <th>Task ID</th>
              <th>Type</th>
              <th>Subtype</th>
              <th>Assigned To</th>
              <th>Status</th>
              <th>Priority</th>
              <th>Created By</th>
            </tr>
          </thead>

          <tbody>
            {
              hasNoData ? (
              <tr>
                <td colSpan={7} className="no-data-cell">
                  No subtasks found
                </td>
              </tr>
            ) : (
              taskData?.map((row, index) => (
                  <tr key={index}>
                      <td
                          // onClick={() => {
                          //     if(component === "Field Update"){
                          //         setShowFieldUpdateModal(true);
                          //     }
                          //     else{
                          //         setShowTaskModal(true);
                          //     }
                          // }}
                      >
                          {row.parent_task_id}
                      </td>
                      <td>{row?.task_type?.type_name}</td>
                      {/* <td>{row?.categories.map((cat) => cat?.category_name)?.join(", ")}</td> */}
                      <td>{row?.category?.category_name}</td>
                      <td>{`${row.assignee?.first_name}${row.assignee?.last_name ? ` ${row.assignee?.last_name}` : ''}`}</td>
                      <td>
                        <span className={`pill status-${row?.status?.status_code?.toLowerCase()}`}>
                            {row?.status?.status_name}
                        </span>
                      </td>
                      <td>
                        <span className={`pill priority-${row?.priority?.priority_name?.toLowerCase()}`}>
                            {row.priority?.priority_name}
                        </span>
                      </td>
                      <td>{`${row.creator?.first_name}${row.creator?.last_name ? ` ${row.creator?.last_name}` : ''}`}</td>
                  </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      {/* <div className="pagination-wrapper">
        <Pagination className="custom-pagination">{paginationItems}</Pagination>
      </div>

        {
            showTaskModal &&
            <TaskModal
                show={showTaskModal}
                onHide={() => setShowTaskModal(false)}
                taskData={taskData}
                fileData={fileData}
            />
        }

        {
            showFieldUpdateModal &&
            <FieldUpdateModal 
                show={showFieldUpdateModal} 
                onHide={() => setShowFieldUpdateModal(false)} 
                taskData={taskData}
                fileData={fileData}
            />
        } */}
    </div>
  )
}

export default UpdateTable